import { CARTINFO_REQUEST, CARTINFO_SUCCESS, CARTINFO_UPDATE, CARTINFO_DELETE, CARTINFO_FAILURE, CARTINFO_CLEAR } from "../constants/ActionTypes";

const initialState = {
    loading: false,
    cartItems: [],
    cartTotal: 0,
    cartItemsCount: 0,
    error: null,
};

export default function cartReducer(state = initialState, action) {
    switch (action.type) {
        case CARTINFO_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CARTINFO_SUCCESS:
            return {
                ...state,
                loading: false,
                // always replacing data
                cartItems: action.data.cart_item,
                cartTotal: action.data.cart_net_amt,
                cartItemsCount: action.data.cart_item_count,
            };
        // case CARTINFO_DELETE:
        //     return {
        //         ...state,
        //         loading: false,
        //         // always replacing data
        //         user_details: [],
        //         isAuth: false
        //     };
        case CARTINFO_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case CARTINFO_CLEAR:
            return {
                ...state,
                loading: false,
                cartItems: [],
                cartTotal: 0,
                cartItemsCount: 0,
            };
        default:
            return state;
    }
}
